import React from "react";
import { BaseCellProps } from "@components/spreadsheet/cells";
import { CatalogItemSelection } from "./CatalogItemCombobox";
import { CatalogItemSearchCellShell } from "./CatalogItemSearchCellShell";

type SpreadsheetCellValue = string | number | boolean | string[] | null;

function stringField(value: SpreadsheetCellValue) {
    return typeof value === "string" ? value : "";
}

function numberOrNull(value: SpreadsheetCellValue) {
    return typeof value === "number" ? value : null;
}

function stringList(value: SpreadsheetCellValue) {
    if (!Array.isArray(value)) {
        return [];
    }
    return value.filter((entry) => typeof entry === "string");
}

function nullableString(value: SpreadsheetCellValue) {
    return typeof value === "string" && value.length > 0 ? value : null;
}

interface Props extends BaseCellProps {
    entityId?: number;
    currency?: string;
    onSelectCatalogItem: (
        lineId: string,
        selection: CatalogItemSelection,
    ) => void;
}

export const CatalogItemSearchCell: React.FC<Props> = ({
    row,
    entityId,
    currency = "usd",
    onSelectCatalogItem,
    ...cellProps
}) => {
    const lineId = typeof row.id === "string" ? row.id : "";

    return (
        <CatalogItemSearchCellShell
            {...cellProps}
            row={row}
            rowId={lineId}
            entityId={entityId}
            currency={currency}
            linePrefill={{
                productOrService: stringField(row.productOrService),
                description: stringField(row.description),
                unitAmount: numberOrNull(row.unitAmount),
                classIds: stringList(row.classIds),
                accrualAccountId: nullableString(row.accrualAccountId),
                receivablesAccountId: nullableString(row.receivablesAccountId),
            }}
            selectOrder="row-update-first"
            onSelectCatalogItem={onSelectCatalogItem}
        />
    );
};
